import { getFromServerToken } from './fetch'
import { useState, useEffect, useContext } from 'react';
import EventContext from "../store/event-context";


const useListActive = () => {
    const [isLoadingActive, setIsLoading] = useState(false);
    const [activeData, setData] = useState();
    const [countActives, setCountActives] = useState("");
    const [activeServerError, setServerError] = useState(null);
    const [toggleRefresh, setToggleRefresh] = useState(false)
    const eventctx = useContext(EventContext);

    const displayCapnr = (capNr) => {
        let result = capNr;
        // console.log("displayCapnr - Capnr: ", capNr, " - Event",eventctx.event)
        if (eventctx.event && eventctx.event.colors.length === 1) {
            const hlpArray = capNr.split(":");
            result = hlpArray[1];
        }
        return result;
    }

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const path = `/events/${eventctx.eventId}/active`
            console.log("Querying: " + path)
            const { data, status } = await getFromServerToken(path)
            if (status !== 200) {
                console.log("Error while retrieving list of actives")
                setServerError(data.detail)
                setData([])
            }
            else {
                console.log("Returned data: ", data);
                console.log("data.active: ", data.active);
                let tmpData = data.active.map((item, index) => {
                    item.fullName = item.firstName + " " + item.lastName;
                    item.displayCapnr = displayCapnr(item.capnr);
                    item.actorId = item.id;
                    return item;
                });
                console.log("Enriched data: ", tmpData);        // Due to Shallow copy, the original data has also changed.
                setCountActives(Object.keys(tmpData).length);
                setData(tmpData); 
            }
            setIsLoading(false);
        };
        fetchData();
    }, [toggleRefresh, eventctx.eventId]);

    const refresh = () => {
        setToggleRefresh(!toggleRefresh)
    }


    return { activeData, countActives, isLoadingActive, activeServerError, refresh };
}

export default useListActive
